import React from 'react'
import {
  E_SIGN_STATUS_AWAITING_SIGNATURE,
  E_SIGN_STATUS_COMPLETED_KYC,
  E_SIGN_STATUS_SIGNED,
  E_SIGN_STATUS_SIGNED_KYC_COMPLETE,
  E_SIGN_STATUS_ABORTED,
  E_SIGN_STATUS_EXPIRED,
} from '../config'
import { formatSnakeCaseToSpaceCase } from '../utils/formatters'

const StatusLabelESign = (props) => {
  let badge = null
  const { state, extraKlass } = props
  const klassLabel = 'label'
  switch (state) {
    case E_SIGN_STATUS_SIGNED_KYC_COMPLETE:
      badge = (
        <span className={`${klassLabel} label-primary text-uppercase ${extraKlass}`}>
          {formatSnakeCaseToSpaceCase(state)}
        </span>
      )
      break
    case E_SIGN_STATUS_AWAITING_SIGNATURE:
      badge = <span className={`${klassLabel} text-uppercase ${extraKlass}`}>{formatSnakeCaseToSpaceCase(state)}</span>
      break
    case E_SIGN_STATUS_SIGNED:
      badge = (
        <span className={`${klassLabel} label-info text-uppercase ${extraKlass}`}>
          {formatSnakeCaseToSpaceCase(state)}
        </span>
      )
      break
    case E_SIGN_STATUS_COMPLETED_KYC:
      badge = (
        <span className={`${klassLabel} label-success text-uppercase ${extraKlass}`}>
          {formatSnakeCaseToSpaceCase(state)}
        </span>
      )
      break
    case E_SIGN_STATUS_ABORTED:
      badge = (
        <span className={`${klassLabel} label-danger text-uppercase ${extraKlass}`}>
          {formatSnakeCaseToSpaceCase(state)}
        </span>
      )
      break
    case E_SIGN_STATUS_EXPIRED:
      badge = (
        <span className={`${klassLabel} label-warning text-uppercase ${extraKlass}`}>
          {formatSnakeCaseToSpaceCase(state)}
        </span>
      )
      break
    default:
  }
  return badge
}

export default StatusLabelESign
